import React from 'react';
import { ReactComponent as IconFacebook } from './assets/icons/facebook.svg';
import { ReactComponent as IconTwitter } from './assets/icons/twitter.svg';
import { ReactComponent as IconGithub } from './assets/icons/github.svg';
import "./App.css";

class App extends React.Component {
  render = () => {
    return (
      <div className="card">
        <div className="header">
          <div className="logo">
            <a href=".">
            <img src={require('./assets/icons/logo.svg').default} alt="Logo" className="icon" style={{ width: '150px' }} />            </a>
          </div>
          <div className="social">
            <a href="https://facebook.com" title="Facebook" target="_blank" rel="noopener noreferrer">
              <IconFacebook className="icon" />
            </a>
            <a href="https://twitter.com" title="Twitter" target="_blank" rel="noopener noreferrer">
              <IconTwitter className="icon" />
            </a>
            <a href="https://github.com" title="GitHub" target="_blank" rel="noopener noreferrer">
              <IconGithub className="icon" />
            </a>
          </div>
        </div>
        <div className="content">
          <div className="title-holder">
            <h1>Get Ready For The Change. We are Coming Soon.<br/> </h1>
            <p style={{ fontSize: '18px' }} ><br/> We are a daily digital news media platform dedicated to promoting a better understanding between the Arab and the West.
 <br /> Stay tuned to discover how our platforms will bridge perspectives and inspire understanding.<br/> <br/> </p>          </div>
          <a href="mailto:contact@memge.eu">
            <div className="cta">Send us an email</div>
          </a>
        </div>
        <div className="footer">
          <span> <br/> <br/> Copyright © : memge.eu 2024</span>
        </div>
      </div>
    );
  }
}

export default App;